module.exports = __webpack_public_path__ + "img/power-level-6.30f1ac14.png";